import { useMemo } from 'react';
import { useStoreStatic } from '~/store/store-context';
import { visibleSortedDrafts } from '../EditDraftsTable.utils';
export function useVisibleSortedDrafts(param) {
    let { drafts, getContact, getClientName, search, aiFilteredIds, sort, anchorSampleLabel, unnamedDraftLabel } = param;
    const { getState } = useStoreStatic();
    return useMemo(()=>{
        var _getState_userInfo_businessSettings, _getState_userInfo;
        return visibleSortedDrafts({
            drafts,
            getContact,
            getClientName,
            search,
            aiFilteredIds,
            sort,
            introductoryMessages: (_getState_userInfo = getState().userInfo) === null || _getState_userInfo === void 0 ? void 0 : (_getState_userInfo_businessSettings = _getState_userInfo.businessSettings()) === null || _getState_userInfo_businessSettings === void 0 ? void 0 : _getState_userInfo_businessSettings.introductoryMessages,
            anchorSampleLabel,
            unnamedDraftLabel
        });
    }, [
        drafts,
        search,
        sort,
        getContact,
        getClientName,
        anchorSampleLabel,
        unnamedDraftLabel,
        aiFilteredIds
    ]);
}
